export default __webpack_public_path__ + "static/media/client-09.30af8577.svg";